import { useParams } from 'react-router-dom';
import { getLatestRoutingPlans } from 'utils/routingPlansUtils';
import useFetchTeamRoutingPlans from 'queries/fetch/fetchTeamRoutingPlans';
import { ITeamLevelParams } from 'utils/parameterUtils';
import ProgressIndicator from 'components/ProgressIndicator';
import ChangeTargetsSection from './ChangeTargetsSection';

function ChangeTargetsPage() {
  const { teamId } = useParams() as ITeamLevelParams;
  const { data, error: fetchError } = useFetchTeamRoutingPlans({ teamId });

  if (!data) {
    return <ProgressIndicator />;
  }

  return (
    <ChangeTargetsSection
      teamId={teamId}
      initialRoutingPlans={getLatestRoutingPlans(data)}
      fetchError={fetchError}
    />
  );
}

export default ChangeTargetsPage;
